import React, { FC, useState } from 'react';
import { Dropdown, Flex, MenuProps } from 'antd';

import ImgHudEnergyBonus from '@/shared/pictures/energy_bonus.png';
import { MyTimer } from '@/shared/ui/MyTimer';
import { useStore } from '@/app/providers/StoreProvider';

export const BonusInfo = () => {
  const { userStore } = useStore();
  const energyRemainingTime = userStore.gameInfo.user.energyRemainingTime;

  const items: MenuProps['items'] = [
    {
      label: (
        <div className='team-bonus'>

            <Flex className='team-bonus_info' gap={10} align='center'>
              <div className='team-bonus_img'>
                <img src={ImgHudEnergyBonus} alt="energy" />
              </div>

              <p>Регенерация</p>
            </Flex>
            <Flex className='team-bonus_time' vertical>
              <p>Осталось времени:</p>
              <MyTimer date={energyRemainingTime}/>
            </Flex>

        </div>
      ),
      key: '0',
    }
  ];
  return (
    <>
    <Dropdown menu={{items}} trigger={['click']} placement="bottomRight">
      <img className='team-bonus_button' src={ImgHudEnergyBonus} alt="energy" />
    </Dropdown>

    </>


  );
};
